import Vue from 'vue'
import Router from 'vue-router'
import main from '@/views/main.vue'
import workinfoshare from '@/views/workinfo-share.vue'

Vue.use(Router)

const config = require('../../config')
let baseUrl = ''
if (process.env.NODE_ENV === 'production') {
    baseUrl = config.build.assetsPublicPath
}

export default new Router({
    mode: 'history',
    base: baseUrl,
    routes: [
        {
            path: '/',
            name: 'main',
            component: main,
            children: [
                {
                    path: '/',
                    name: 'workinfoshare',
                    component: workinfoshare
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js